export const isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
export const isTest = process.env.NODE_ENV === 'test';
export default {
  landingHost: isDev ? '//localhost:3000' : '//www.inmoblex.com',
  host: isDev ? '//www.verinmuebles.test' : '//www.verinmuebles.com',
  insecureHost: isDev ? 'http://www.verinmuebles.dev' : 'http://www.verinmuebles.com',
  apihost: isDev ? '//djapi.verinmuebles.test' : '//djapi.verinmuebles.com',
  dashHost: isDev ? '//localhost:3001' : '//dashboard.inmoblex.com',
  photosHost: isDev ? '//photos.verinmuebles.test' : '//photos.verinmuebles.com',
};



// WEBPACK FOOTER //
// ./src/config.js